import type { PropsWithChildren } from 'react';
import { useHistory } from 'react-router-dom';
import { Auth0Provider as OGAuth0Provider } from '@auth0/auth0-react';

import { appConfig } from '@/config';
import {
  SESSION_STORAGE_KEYS,
  SESSION_STORAGE_VALUES,
} from '@/constants/session-storage';

export type Auth0ProviderProps = PropsWithChildren<{}>;

export function Auth0Provider({ children }: Auth0ProviderProps) {
  const history = useHistory();

  return (
    <OGAuth0Provider
      domain={appConfig.auth0.domain}
      clientId={appConfig.auth0.clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: appConfig.auth0.audience,
        scope: appConfig.auth0.scope,
        display: 'page',
      }}
      onRedirectCallback={function (appState) {
        // Set a temporary flag to indicate user just signed in
        sessionStorage.setItem(
          SESSION_STORAGE_KEYS.USER_JUST_SIGNED_IN,
          SESSION_STORAGE_VALUES.USER_JUST_SIGNED_IN,
        );
        history.replace(appState?.returnTo ?? window.location.pathname);
      }}
      useRefreshTokens
      useRefreshTokensFallback
      // TODO: remove this after the release
      cacheLocation="localstorage"
    >
      {children}
    </OGAuth0Provider>
  );
}
